interface Props {
    color?: string
}

export function SaveIcon(props: Props) {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M15 19V11H5V19M5 1V6H13M17 19H3C2.46957 19 1.96086 18.7893 1.58579 18.4142C1.21071 18.0391 1 17.5304 1 17V3C1 2.46957 1.21071 1.96086 1.58579 1.58579C1.96086 1.21071 2.46957 1 3 1H14L19 6V17C19 17.5304 18.7893 18.0391 18.4142 18.4142C18.0391 18.7893 17.5304 19 17 19Z" stroke={props.color ? props.color : "#8383AD"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}
